import icons from 'assets/icons'
import React, { useState, useEffect } from 'react'
import Button from './../formElements/Button'
import PropTypes from 'prop-types'
import useWindowSize from './../../hooks/useWindowSize'
import { useRequest } from 'hooks/useRequest'
import useToast from 'hooks/useToast'
import { Dialog } from 'primereact/dialog'
import { InputText } from 'primereact/inputtext'
import { validateEmail } from 'utils/MailValidator'
import { InputMask } from 'primereact/inputmask'
import DefaultSelect from 'components/formElements/DefaultSelect'
const UsersHeader = ({ listType, setListType, createUser, setCreateUser, filterOptions, setFilterOptions }) => {
	const { width } = useWindowSize()
	const [addUser] = useRequest()
	const { showToast } = useToast()
	const [getAllRoles] = useRequest()
	const [roles, setRoles] = useState([])
	const [addLogForm, setAddLogForm] = useState({
		firstName: '',
		lastName: '',
		password: '',
		email: '',
		roles: [],
		accountId:""
	})
	useEffect(() => {
		if (createUser) {
			getAllRoles('/Role/GetAllRoles', { method: 'GET' }).then((res) => {
				setRoles(res.data.result.map(r => ({ label: r.name, value: r.name == 'Accounting' ? 'ACCOUNTİNG' : r.name.toUpperCase() })))
			})
			setAddLogForm({
				firstName: '',
				lastName: '',
				password: '',
				email: '',
				roles: [],
				accountId:""
			})
		}
	}, [createUser])
	const createUserFunc = () => {
		setCreateUser(true)
	}
	const handleChange = (e, name) => {
		if (name) {
			setAddLogForm((prev) => ({ ...prev, [name]: e }))
		} else {
			setAddLogForm((prev) => ({ ...prev, [e.target.name]: e.target.value }))
		}
	}
	const handleSubmit = async () => {
		console.log(addLogForm?.roles);
		if (!addLogForm.firstName) {
			showToast('Kullanıcı Adını Giriniz', 'error')
		} else if (!addLogForm.lastName) {
			showToast('Kullanıcı Soyadını Giriniz', 'error')
		} else if (!validateEmail(addLogForm.email)) {
			showToast('Kullanıcı Mail Adresini Doğru Formatta Giriniz', 'error')
		} else if (addLogForm.password.length < 6) {
			showToast('Şifreniz 6 karakterden büyük olmalı', 'error')
		} else {
			addUser('/Account/Register', {
				method: 'POST',
				data: { ...addLogForm, roles: Array.isArray(addLogForm?.roles) ? addLogForm?.roles?.map(r => r.value) : [addLogForm.roles.value] },
			}).then((res) => {
				if (res.data.ok) {
					showToast('Kullanıcı Eklendi', 'success')
					setCreateUser(false)
				} else {
					showToast(res.data.metadata.message, 'error')
				}
			})
		}
	}

	return (
		<div className='users-header'>
			<span className='p-input-icon-left'>
				<i className='pi pi-search' />
				{filterOptions.searchText && <i className="pi pi-times" style={{cursor: 'pointer', right: '10px'}} onClick={() => setFilterOptions({ ...filterOptions, searchText: '' })} />}
				<input
					className='default-input pl-5 pr-4'
					type='text'
					value={filterOptions.searchText}
					onChange={(e) => setFilterOptions({ searchText: e.target.value })}
					placeholder={'Arama Yapın...'}
				/>
			</span>
			<div className='users-header-right'>
				<Button
					handleClick={() => createUserFunc()}
					icon={<icons.plus size={17} />}
					className='btn-success'
					title={width <= 936 ? '' : 'Yeni Kullanıcı Ekle'}
				/>
				<div className='users-header-right-display'>
					<icons.menu
						onClick={() => setListType(1)}
						size={23}
						color={listType == 1 && 'green'}
						className='text-bold users-header-right-display-icon'
					/>
					<icons.dashboardList
						onClick={() => setListType(2)}
						size={20}
						color={listType == 2 && 'green'}
						className='text-bold users-header-right-display-icon'
					/>
				</div>
			</div>
			{createUser && (
				<Dialog visible={createUser} onHide={setCreateUser} draggable={false} header='Yeni Kullanıcı Ekleme'>
					<div className='form d-flex flex-column gap-3 mt-2'>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<InputText
										placeholder={'Kullanıcı Adı'}
										name='firstName'
										type='text'
										onChange={handleChange}
										className='default-input input-border'
									/>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<InputText placeholder={'Kullanıcı Soyadı'} name='lastName' type='text' onChange={handleChange} className=' input-border' />
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<InputText
										name='email'
										placeholder={'Email Adresi'}
										type='email'
										required
										onChange={handleChange}
										className='default-input input-border'
									/>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<DefaultSelect
										isMulti
										name='roles'
										placeholder={'Kullanıcı Rolü'}
										selectOptions={roles}
										handleChange={(e) => handleChange(e, 'roles')}
									/>
								</div>
							</div>
						</div>
						<div className='row'>
							<div className='col-md-6'>
								<div className='form-control'>
									<InputMask
										name='phoneNumber'
										mask='(999) 999-9999'
										placeholder={'Telefon Numarası'}
										onChange={handleChange}
										className=' input-border'
									/>
								</div>
							</div>
							<div className='col-md-6'>
								<div className='form-control'>
									<InputText name='password' placeholder={'Şifre'} type='password' onChange={handleChange} className=' input-border' />
								</div>
							</div>
						</div>

						<div className='row'>
							<div className='col-md-6 offset-md-6'>
								<div className='form-control align-items-end '>
									<Button
										icon={<icons.addUser className='mr-1' size={20} />}
										className='btn-success'
										title='Kullanıcı Ekle'
										handleClick={handleSubmit}
									/>
								</div>
							</div>
						</div>
					</div>
				</Dialog>
			)}
		</div>
	)
}

UsersHeader.proptypes = {
	listType: PropTypes.num,
	setListType: PropTypes.func,
	createUser: PropTypes.bool,
	setCreateUser: PropTypes.func,
}

export default UsersHeader
